<div class="body-container-wrapper">
    <section class="inner-page-banner h400-banner retirement-banner rm-banner" >
        <div class="container">
            <div class="banner-caption">
                <h1>Match Your RM</h1>
                <h6>Match with one of our Relationship Managers (RMs) to get the best financial advice on your terms. Get the expertise of a fully qualified adviser.</h6>
            </div>
        </div>
    </section>
    <section class="bgwhite">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-lg-11 col-xl-8">
        <div class="card banner-form">
            <div class="card-body">
                    <form autocomplete="off" class="row">
                  <div class="col-12">
                    <h4 class="mt-2" style="margin-bottom: 2rem;"><strong>Enter your details below and let our RM Engine
                        do its magic.</strong></h4>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="">Full Name <span class="asterisk"></span></label>
                    <input type="text" onpaste="return false" id="name" name="name" class="form-control" placeholder="Please enter your full name" maxlength="40" onkeypress='return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32) || event.which == 8'>
                    <!-- <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
                      Invalid full name
                    </div>
                    <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
                      Full name is mandatory
                    </div> -->
                  </div>
                  <div class="form-group custom-dropdown col-md-6">
                    <label for="">Key Financial Need <span class="asterisk"></span></label>
                    <select class="selected-item  form-control" id="serviceid" name="serviceid">
                      <option value="">Pick key financial need</option>
                      <!-- <ng-container *ngFor="let product of productArr">
                        <option [value]="product.tid" *ngIf="product.status=='True'">
                                    {{product.name}}
                        </option>
                    </ng-container> -->
                    </select>
                    <!-- <div class="errormsg" *ngIf="productValidateMessage == 'required'">
                        Product selection is mandatory
                    </div>  -->
                  </div>
  
                <div class="form-group col-md-6">
                    <label for="">Phone <span class="asterisk"></span></label>
                    <input type="text" (keydown.space)="$event.preventDefault();" onpaste="return false" id="mobile" name="mobile" class="form-control" placeholder="Enter Your mobile number"  minlength="10" maxlength="10" pattern="[6789][0-9]{9}" onkeypress='return (event.charCode > 47 && event.charCode <= 57) || event.which == 8'>
                    <!-- <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
                        10 digit mobile number is mandatory
                    </div>
                    <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
                    Invalid mobile number
                    </div>
                    <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
                    Mobile number is mandatory
                    </div> -->
  
                </div>
                  <div class="form-group col-md-6">
                    <label for="">Email ADDRESS  <sup>(optional)</sup><span class="asterisk"></span></label>
                    <input type="text" (keydown.space)="$event.preventDefault();" onpaste="return false" id="email" name="email" class="form-control" placeholder="Your email id" maxlength="50">
                    <!-- <div class="errormsg" *ngIf="emailValidateMessage == 'invalid'">
                        Invalid email id
                    </div> -->
                    <!-- <div class="errormsg"  *ngIf="emailValidateMessage == 'required'">
                            Email id is mandatory
                    </div>  -->
                  </div> 
                  <div class="form-group col-md-6">
                    <label for="">Pincode <span class="asterisk"></span></label>
                    <input type="text" autocomplete="off" id="pincode" name="pincode" class="form-control" placeholder="Your pincode" pattern="^[1-9][0-9]{5}$" minlength="6" maxlength="6" 
                      onkeypress="return (event.charCode > 47 && event.charCode <= 57) || event.which == 8">
                    <!-- <div class="errormsg"  *ngIf="pinValidateMessage == 'invalid'">
                        Invalid pincode
                    </div> 
                    <div class="errormsg" *ngIf="pinValidateMessage == 'required'">
                        Pincode is mandatory
                    </div>
                    <div class="errormsg" *ngIf="pinValidateMessage == 'notselected'">
                      Pincode selection from the list is mandatory
                    </div> -->
                    
                    <div class="suggestion-box" id="suggestion-box">
                        <!-- <div style="padding:10px;" *ngFor="let pin of pincodeArr"><a class="pointer" (mousedown)="setpincode(pin)">{{pin.pincode}} - {{pin.cityname}}</a></div>     -->
                       <!-- <ng-container  *ngFor="let pin of pincodeArr">
                        <a class="pointer" (mousedown)="setpincode(pin)"><div style="padding:10px;">{{pin.pincode}} - {{pin.cityname}}</div></a>
                       </ng-container> -->
                    </div>
                  </div>
                  
                  <div class="form-group col-md-6" id="displayNone"  style="display: none;">
                      <label for=""><span class="asterisk">City</span></label>
                      <input readonly type="text" autocomplete="off"  id="city" name="city" class="form-control" >
                  </div>
                 
                  <div class="form-group text-center col-12">
                    <button type="submit" class="btn btn-primary" id="otp_verify_btn">Continue</button>
                 </div> 
                 <div class="col-md-12 text-center">
                    <label class="disclaimer">By continuing, you provide consent and agree to our <a [routerLink]="['/term-conditions']" [queryParams]="{doc:'tnc'}">Terms & Conditions.</a> 
                    </label>
                </div>
                </form>
            </div>
                <!--OTP FORM START-->
            <div class="card-body  otp-card" >
                <form >
                  <div class="col-12">
                    <h4 class="mt-2" style="margin-bottom: 2rem;"><strong>Enter your details below and let our RM Engine
                        do its magic.</strong></h4>
                  </div>
                  <p class="mb-3"><a href="javascript:void(0)" id="btn-back" ><i class="fa fa-chevron-left"></i> Change Number</a></p>
                  <div class="alert alert-success"><i class="fa fa-check"></i> <span class="ms-3">OTP successfully sent on number</span>
                  </div>
                  <div class="form-group" style="max-width: 400px;">
                    <input type="text" (keydown.space)="$event.preventDefault();" onpaste="return false" id="otp" name="otp" class="form-control" maxlength="6" placeholder="Enter OTP"  onkeypress='return (event.charCode > 47 && event.charCode <= 57) || event.which == 8'>
                    <!-- <div class="errormsg" *ngIf='!otpVerifiedStatus'>
                      Invalid OTP
                    </div>
                    <div class="errormsg" *ngIf="otpValidateMessage == 'required'">
                      Please enter OTP to continue.  
                  </div> -->
                  </div>
                  <div class="form-group text-center">
                    <button type="submit" class="btn btn-primary" id="otp_verify_btn">Submit</button>
                </div>
  
                <div class="col-md-12 text-center">
                   <p class="timer">Didn't recieve OTP? Resend in <strong style="font-size:17px;">30</strong> seconds</p>
                    <a class="resendotp" href="javascript:void(0)">Resend OTP</a>
                </div>
                </form>
            </div>
  
                <!--OPT FORM END-->
            </div> <!--Card END-->
          </div>
        </div>
      </div>
    </section>
  </div>
  